import PageHeader from "../components/layout/PageHeader";
import ContactCTA from "../components/sections/ContactCTA";
import { industries } from "../lib/content";
import { motion } from "framer-motion";

export default function Industries() {
    return (
        <div data-testid="industries-page">
            <PageHeader
                eyebrow="Industries"
                title={<>Engineered for <span className="text-blue-400">precision-critical</span> sectors.</>}
                description="Every industry has its own constraints, codes and operating realities. We've built deep expertise across eight sectors — so we speak your language from kickoff."
            />

            <section className="py-16 md:py-24 border-t border-white/5">
                <div className="max-w-7xl mx-auto px-6 md:px-10 space-y-6">
                    {industries.map((ind, i) => (
                        <motion.div
                            key={ind.slug}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.6 }}
                            className="group grid grid-cols-1 md:grid-cols-12 gap-6 p-6 md:p-8 rounded-3xl bg-slate-900/40 backdrop-blur-xl border border-white/5 hover:border-blue-500/40 transition-all duration-500"
                            data-testid={`industry-row-${ind.slug}`}
                        >
                            <div className="md:col-span-5 relative rounded-2xl overflow-hidden aspect-[4/3] md:aspect-auto">
                                <img
                                    src={ind.image}
                                    alt={ind.title}
                                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-tr from-slate-900/60 via-transparent to-transparent" />
                            </div>
                            <div className="md:col-span-7 flex flex-col justify-center">
                                <div className="flex items-center gap-3 mb-4">
                                    <span className="font-mono text-[10px] tracking-[0.3em] text-cyan-400/80">{ind.code}</span>
                                    <span className="h-px flex-1 bg-white/10" />
                                </div>
                                <h2 className="font-heading font-black text-white text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tighter mb-5">
                                    {ind.title}
                                </h2>
                                <p className="text-base md:text-lg text-slate-400 leading-relaxed mb-6 max-w-xl">
                                    {ind.short}
                                </p>
                                <div className="flex flex-wrap gap-2">
                                    {ind.sub.map((s) => (
                                        <span
                                            key={s}
                                            className="inline-flex items-center px-3 py-1.5 rounded-full bg-blue-500/10 border border-blue-500/20 text-xs text-blue-200 font-medium"
                                        >
                                            {s}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </section>

            <ContactCTA compact />
        </div>
    );
}
